/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.ProductDevelopment {
    @Serenity.Decorators.registerClass()
    export class CustomerRequirementStoneItemsDialog extends _Ext.EditorDialogBase<CustomerRequirementStoneItemsRow> {
        protected getFormKey() { return CustomerRequirementStoneItemsForm.formKey; }
        protected getLocalTextPrefix() { return CustomerRequirementStoneItemsRow.localTextPrefix; }

        public form = new CustomerRequirementStoneItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }



        // #endregion 

        // #region Constructor
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;

            // #region UI
            //Make grid full width 
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            // #endregion


            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;

                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    //ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);


                    if (this.form.ProductTypeId.value == "11") {

                        var mapping = (this.parentEditor.parentDialog as CustomerRequirementItemsDialog).form.MappingId.selectedItem;

                        this.form.StoneColorId.value = mapping.StoneColorId;
                        this.form.QualityId.value = mapping.QualityId;
                    } else {
                        this.form.StoneColorId.value = "";
                        this.form.QualityId.value = "";
                    }

                }
            });


            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.ProductTypeId.changeSelect2(e => {
                var producttype = this.form.ProductTypeId.value;
                if (producttype == "12") {
                    q.showField(this.form.CategoryId);
                    q.showField(this.form.SubCategoryId);
                } else if (producttype == "11") {
                    q.showField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                }
                this.form.SubCategoryId.updateItems();
                this.form.CategoryId.updateItems();
            })

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })
        }

        // #endregion

        // #region Open Dialog, Close Dialog etc

        // **** Load Entity event to set fields values ****
        protected onDialogOpen() {
            super.onDialogOpen();
            
            var mapping = (this.parentEditor.parentDialog as CustomerRequirementItemsDialog).form.MappingId.selectedItem;
            if (mapping == null) {
                Q.warning('Please select Color and Quality before adding stone');
                this.dialogClose();
                return;

            } 
            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
                this.form.CategoryId.ItemTypeId = 105;
                this.form.CategoryId.updateItems();

            } else {
                let categoryid = this.form.CategoryId.value;

                this.form.CategoryId.ItemTypeId = 105;
                this.form.CategoryId.updateItems();
                this.form.CategoryId.value = categoryid;
                var producttype = this.form.ProductTypeId.value;
                if (producttype == "12") {
                    q.showField(this.form.CategoryId);
                    q.showField(this.form.SubCategoryId);
                } else if (producttype == "11") {
                    q.showField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                }
            }// ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

            q.HideCategoryLable(this.element);
            q.hideField(this.form.ProductCode); 
        }
        // #endregion        

        protected validateBeforeSave() {
            this.form.AttributeId.value = "0";

            this.entity.RefTransId == null ? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null ? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null ? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null ? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null ? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null ? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null ? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount



            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                return false;
            }
            else {
                return true;
            }

        }
        // #endregion 
    }
}